<ng-container [ngSwitch]="isAdded">
  <!-- Check -->
  <svg *ngSwitchCase="true" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none">
      <g stroke="#4FCC53">
        <g transform="translate(-466 -281)translate(78 73)translate(30 136)translate(2 56)translate(356 16)">
        <circle cx="12" cy="12" r="11.5"/>
        <polyline points="6.5 12 10.5 16 17.5 7.5"/>
        </g>
      </g>
    </g>
  </svg>
  <!-- /.Check -->

  <!-- Add -->
  <svg *ngSwitchDefault xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
    <g fill="none">
      <g stroke="#CDD3D8">
        <circle cx="12" cy="12" r="11.5"/>
        <path d="M12 6L12 18 12 6Z"/>
        <path d="M6-0.5L-6-0.5 6-0.5Z" transform="translate(-989 -344)translate(603 73)translate(30 136)translate(0 55)translate(0 64)translate(356 16)translate(12 12.5)scale(-1 1)"/>
      </g>
    </g>
  </svg>
  <!-- /.Add -->
</ng-container>

